<script>
import axios from "axios";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Verify PIN",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      phone: localStorage.getItem("phone"),
      error: "",
      loader: false,
      pin: ['', '', '', '','', ''], // Array to hold each digit of the PIN
    };
  },
  computed: {
    pinValue() {
      return this.pin.join('');
    },
    isPinValid() {
      return this.pin.every((digit) => /^[0-9]$/.test(digit));
    },
  },
  methods: {
    
    isValidDigit(digit) {
      return digit === '' || /^[0-9]$/.test(digit);
    },
    handleInput(index) {
      // Auto-focus next input if a digit is entered
      if (this.pin[index] && index < this.pin.length - 1) {
        this.$refs[`pinInput${index + 1}`][0].focus();
      }
    },
    handleKeydown(index, event) {
      // Handle backspace to move to previous input
      if (event.key === 'Backspace' && !this.pin[index] && index > 0) {
        this.$refs[`pinInput${index - 1}`][0].focus();
      }
    },
    handlePaste(event) {
      // Handle pasting a PIN code
      event.preventDefault();
      const pastedData = event.clipboardData.getData('text').replace(/\D/g, '');
      if (pastedData.length <= this.pin.length) {
        for (let i = 0; i < pastedData.length && i < this.pin.length; i++) {
          this.$set(this.pin, i, pastedData[i]);
        }
        // Focus the last filled input or the next empty one
        const nextIndex = Math.min(pastedData.length, this.pin.length - 1);
        this.$refs[`pinInput${nextIndex}`][0].focus();
      }
    },
    async submitPin() {
      if (this.isPinValid) {
        this.loader = true;
        let formData = new FormData();
        formData.append("phone", "+256"+this.phone);
        formData.append("otp", this.pinValue);
        let url = "/verify_otp";
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            let error = response.data.error;
            if (!error) {
              this.error = response.data.msg;
              // this.getMember("+256"+this.phone);
              this.$router.push({name: "register",});
            } else {
              this.error = response.data.msg;
            }
            this.loader = false;
          } else {
            this.error = response.data.msg;
            this.loader = false;
          }
        });
      }
    },

    async getMember(phonenumber) {
      this.loader = true;
      let formData = new FormData();
      formData.append("phone", phonenumber);
      await axios.get('/member/phone/'+phonenumber).then((response) => {
        let error = response.data.error;
        if (error) {
           this.error = response.data.msg;
        } else {
          let memberData=response.data.data;
          localStorage.setItem('member', JSON.stringify(memberData))
          this.$router.push({name: "home",})
          this.loader = false;
        }
      });
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div
          class="col-md-7 d-none d-md-block"
          :style="{
            backgroundImage: `url(${require('@/assets/images/president.jpg')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }"
        >
        </div>
        <div class="col-xl-5">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="my-auto">
                  <div class="d-flex flex-row">
                    <span class="mt-3"
                      ><br /><img height="60px" src="@/assets/images/logo.jpeg"
                    /></span>
                    <span class="mt-5 ms-3"
                      ><h5 class="text-primary">My FDC</h5>
                      <b class="h6 text-muted">+256{{phone}}</b></span
                    >
                  </div>

                  <div
                    v-if="error"
                    class="bg-danger text-white p-2 mt-3"
                    style="font-size:12px"
                  >
                    {{ error }}
                  </div>

                  <div class="pin-input- mt-4">
                  <b-form-group label="Enter your verification Code " label-for="pin-input-1">
                    <div class="d-flex justify-content-start">
                      <b-form-input
                        v-for="(digit, index) in pin"
                        :key="index"
                        :id="`pin-input-${index + 1}`"
                        v-model="pin[index]"
                        type="text"
                        maxlength="1"
                        size="sm"
                        class="pin-input mx-1 text-center"
                        @input="handleInput(index)"
                        @keydown="handleKeydown(index, $event)"
                        @paste="handlePaste($event)"
                        :ref="`pinInput${index}`"
                        :state="null" 
                        pattern="[0-9]*"
                        inputmode="numeric"
                      ></b-form-input>
                    </div>
                    <b-form-invalid-feedback v-if="!isPinValid">
                      Please enter a valid 6-digit Code.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-button class="mt-3 w-100" variant="primary" @click="submitPin" :disabled="!isPinValid">
                    VERIFY <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/>
                  </b-button>
                </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pin-input {
  width: 50px;
  height: 50px;
  font-size: 1.5rem;
}
</style>